import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { HmfProgressRingComponent } from '@dsg-tech/homefield-angular';
import { PersonalInformation } from '@shared/data-access/interfaces';
import { Store } from '@shared/data-access/services';

@Component({
    selector: 'common-gold-progress-ring',
    templateUrl: './gold-progress-ring.component.html',
    imports: [CommonModule, HmfProgressRingComponent]
})
export class GoldProgressRingComponent implements OnInit, OnDestroy {
	currentSalesBalance = 0;
	isGold = false;
	salesTarget = 500;
	private ngUnsubscribe: Subject<void> = new Subject();

	@Input() size = 'large';

	constructor(private store: Store) {}

	ngOnInit() {
		this.store.select<PersonalInformation>('PERSONAL_INFO', true)
			.pipe(takeUntil(this.ngUnsubscribe)).subscribe((personalInfo) => {
				const currentYearSales = personalInfo.currentYearSales;
				this.isGold = personalInfo.isGold;

				if (!this.isGold) {
					this.currentSalesBalance = currentYearSales;
				} else if (currentYearSales >= this.salesTarget) {
					this.currentSalesBalance = this.salesTarget;
				} else {
					this.currentSalesBalance = currentYearSales + this.salesTarget;
				}
			});
	}

	ngOnDestroy(): void {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}
}
